//@flow
import { handleMutationError } from "../API"
import type { UpdateSensorMutation, Sensor } from "./types"

const handleSubmit = (
  id: string,
  updateSensor: UpdateSensorMutation,
  onSuccess: Function
) => async (sensor: Sensor) => {
  try {
    await updateSensor(id, sensor)
    onSuccess()
  } catch (mutationError) {
    const errorString: string = mutationError
    handleMutationError(errorString)
  }
}

export default handleSubmit



// WEBPACK FOOTER //
// ./src/Sensors/handleSubmit.js